module.exports = __webpack_public_path__ + "static/media/sunday_times.0aad91a8.png";